import { render } from "./AccountTotal.vue?vue&type=template&id=7b607c1e&scoped=true"
import script from "./AccountTotal.vue?vue&type=script&lang=js"
export * from "./AccountTotal.vue?vue&type=script&lang=js"

import "./AccountTotal.vue?vue&type=style&index=0&id=7b607c1e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7b607c1e"

export default script